import TextWithLineBreaks from './TextWithLineBreaks'
export { TextWithLineBreaks }
export default TextWithLineBreaks
